import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import './index.css';
import './App.css';
import './assets/nextgen-global.min.css';
import { ThemeProvider } from '@lsq/nextgen/v2/stylesmanager';
import { CoralogixRum } from '@coralogix/browser';
import { monitoringConfig } from './utils/config';
import { getUserDetails } from './utils/authUtils';
import { setUserContext } from './utils/monitoring';

CoralogixRum.init(monitoringConfig);

const _user = getUserDetails();
setUserContext({
  userId:  _user?.Id,
  orgCode: _user?.OrgCode,
});

const renderApp = (containerId) => {
  ReactDOM.render(
    <ThemeProvider>
      <App />
    </ThemeProvider>,
    document.getElementById(containerId)
  );
};

export { renderApp };

// For local development
if (process.env.NODE_ENV === 'development') {
  renderApp('root');
}